import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './SubscriptionPlan.module.css';

const getPlanIcon = id => {
  const normalizedId = id?.toLowerCase();
  switch (normalizedId) {
    case 'starter':
    case 'lite':
      return (
        <div className={`${css.planIconCircle} ${css.liteIconCircle}`} aria-hidden="true">
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="52" height="52" rx="26" fill="#EBF3F0" />
            <path
              d="M20.675 31.325C17.775 28.4249 17.775 23.723 20.675 20.8229C24.6133 16.8847 34.459 17.541 34.459 17.541C34.459 17.541 35.1154 27.3867 31.1771 31.325C29.2327 33.2694 26.4783 33.9101 24 33.2472"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.5 34.5L29.5 22.5"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </div>
      );
    case 'regular':
    case 'standard':
      return (
        <div className={`${css.planIconCircle} ${css.standardIconCircle}`} aria-hidden="true">
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="52" height="52" rx="26" fill="#FAEDE2" />
            <path
              d="M27.7276 17.4442L29.4874 20.9929C29.7274 21.4869 30.3673 21.9607 30.9073 22.0514L34.0969 22.5857C36.1367 22.9285 36.6167 24.4206 35.1468 25.8925L32.6671 28.3927C32.2471 28.8161 32.0172 29.6327 32.1471 30.2175L32.8571 33.3125C33.417 35.7623 32.1271 36.71 29.9774 35.4296L26.9877 33.6452C26.4478 33.3226 25.5579 33.3226 25.0079 33.6452L22.0183 35.4296C19.8785 36.71 18.5786 35.7522 19.1386 33.3125L19.8485 30.2175C19.9785 29.6327 19.7485 28.8161 19.3286 28.3927L16.8488 25.8925C15.389 24.4206 15.8589 22.9285 17.8987 22.5857L21.0884 22.0514C21.6183 21.9607 22.2582 21.4869 22.4982 20.9929L24.258 17.4442C25.2179 15.5186 26.7777 15.5186 27.7276 17.4442Z"
              stroke="#D64000"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      );
    case 'plus':
    case 'intensive':
      return (
        <div className={`${css.planIconCircle} ${css.intensiveIconCircle}`} aria-hidden="true">
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="52" height="52" rx="26" fill="#EBF3F0" />
            <path
              d="M21 25.2947C26.284 15.4466 32.8635 15.333 35.4928 16.5072C36.667 19.1365 36.5534 25.716 26.7053 31C26.6031 30.4129 26.0352 28.8749 24.5801 27.4199C23.1251 25.9648 21.5871 25.3969 21 25.2947Z"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28 30.8C30.0428 31.7334 30.2609 33.4069 30.5439 35C30.5439 35 34.8223 32.0481 32.0856 28"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.2 23.9999C20.2666 21.9571 18.5931 21.739 17 21.456C17 21.456 19.9519 17.1775 24 19.9143"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.2086 27.9998C19.5768 28.6317 18.5025 30.4642 19.2608 32.739C21.5356 33.4973 23.3681 32.4231 24 31.7912"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="30.25" cy="21.75" r="1.85" stroke="#00674F" strokeWidth="1.8" />
          </svg>
        </div>
      );
    case 'premium':
    case 'family':
      return (
        <div className={`${css.planIconCircle} ${css.familyIconCircle}`} aria-hidden="true">
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="52" height="52" rx="26" fill="#EBF3F0" />
            <path
              d="M30 35C29.7668 32.0685 27.3422 29.7477 24.3085 29.5521L23.5 29.5C23.2112 29.5076 22.9421 29.5178 22.6882 29.5298C19.6812 29.6723 17.2309 32.0974 17 35"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="23.5" cy="23.75" r="3.25" stroke="#00674F" strokeWidth="1.8" />
            <path
              d="M35 31.501C34.7709 28.6314 32.4541 26.2748 29.5 25.9961"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M29.9876 23C30.8964 22.4243 31.5 21.4079 31.5 20.25C31.5 18.4551 30.0495 17 28.2601 17C27.381 17 26.5837 17.3512 26 17.9214"
              stroke="#00674F"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      );
    default:
      return null;
  }
};

const isMatchingPlan = (activePlanId, cardPlanId) => {
  if (!activePlanId || !cardPlanId) return false;
  const a = activePlanId.toLowerCase();
  const c = cardPlanId.toLowerCase();
  if (a === c) return true;
  if ((a === 'starter' || a === 'lite') && (c === 'starter' || c === 'lite')) return true;
  if ((a === 'regular' || a === 'standard') && (c === 'regular' || c === 'standard')) return true;
  if ((a === 'plus' || a === 'intensive') && (c === 'plus' || c === 'intensive')) return true;
  if ((a === 'premium' || a === 'family') && (c === 'premium' || c === 'family')) return true;
  return false;
};

const SubscriptionPlanGrid = ({
  plans,
  subStatus,
  currentUser,
  loadingPlanId,
  selectedPlan,
  renderPrice,
  getFeatureContent,
  handleSelectPlan,
}) => {
  const intl = useIntl();

  return (
    <div className={css.plansContainer}>
      {plans.map(plan => {
        const isCurrentPlan =
          (subStatus?.status === 'active' || subStatus?.status === 'past_due') &&
          isMatchingPlan(subStatus?.planId, plan.id);
        const isPopular = plan.popular || plan.id === 'standard' || plan.id === 'regular';

        return (
          <div
            key={plan.id}
            className={`${css.planCard} ${isCurrentPlan ? css.currentPlanCard : ''} ${
              isPopular ? css.popular : ''
            }`}
          >
            <div className={css.planHeader}>
              <div className={css.planTopRow}>{getPlanIcon(plan.id)}</div>

              <div className={css.planNameRow}>
                <h2 className={css.planName}>{plan.name}</h2>
                {isPopular && (
                  <span className={css.popularBadge}>
                    {intl.formatMessage({
                      id: 'SubscriptionPlan.plan.popularBadge',
                      defaultMessage: 'Popular',
                    })}
                  </span>
                )}
              </div>

              <p className={css.planDescription}>{plan.description}</p>

              <div className={css.priceContainer}>
                <span className={isPopular ? css.pricePopular : css.price}>
                  {renderPrice(plan.price)}
                </span>
                <span className={css.period}>/ month</span>
              </div>

              <div className={css.credits}>
                <span className={css.creditBold}>{renderPrice(`USD ${plan.credits}`)}</span>{' '}
                {intl.formatMessage({
                  id: 'SubscriptionPlan.plan.receivedLabel',
                  defaultMessage: 'Wallet Value',
                })}
              </div>

              <div className={css.planHeaderDivider} />

              <div className={css.ctaButtonWrapper}>
                <button
                  type="button"
                  className={`${css.ctaButton} ${
                    isCurrentPlan
                      ? css.currentPlanButton
                      : isPopular
                      ? css.popularButton
                      : css.defaultButton
                  }`}
                  onClick={() => handleSelectPlan(plan)}
                  disabled={loadingPlanId === plan.id || isCurrentPlan}
                >
                  {isCurrentPlan
                    ? intl.formatMessage({
                        id: 'SubscriptionPlan.plan.current',
                        defaultMessage: 'Current Plan',
                      })
                    : selectedPlan?.id === plan.id
                    ? intl.formatMessage({
                        id: 'SubscriptionPlan.plan.selected',
                        defaultMessage: 'Selected',
                      })
                    : plan.buttonText ||
                      intl.formatMessage({
                        id: 'SubscriptionPlan.plan.selectButton',
                        defaultMessage: 'Select Plan',
                      })}
                </button>
              </div>
            </div>

            <div className={css.panelBody}>
              <ul className={css.featuresList}>
                {plan.features.map((feature, index) => (
                  <li key={index} className={css.featureItem}>
                    <span className={css.checkmark} aria-hidden="true">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.6663 5L7.49967 14.1667L3.33301 10"
                          stroke={isPopular ? '#D64000' : '#00674F'}
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span
                      className={css.featureText}
                      dangerouslySetInnerHTML={{ __html: getFeatureContent(feature, plan) }}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SubscriptionPlanGrid;
